import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RoutingService } from '@spartacus/core';
import { VizseekService } from 'src/app/customServices/vizseek.service';
import { KbVizseekYesPopupComponent } from './kb-vizseek-yes-popup/kb-vizseek-yes-popup.component';
import { KbVizseekNoresultsPopupComponent } from './kb-vizseek-noresults-popup/kb-vizseek-noresults-popup.component';
import { Overlay } from '@angular/cdk/overlay';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SecureGuard } from 'src/app/services/Guards/secure.service';

@Component({
  selector: 'app-kb-vizseek',
  templateUrl: './kb-vizseek.component.html',
  styleUrls: ['./kb-vizseek.component.scss'],
  standalone: false
})
export class KbVizseekComponent {
  //secure Guard changes
  state: boolean = true;
  private secureSubscription$ = new Subject<void>();
  @ViewChild('fileInput') fileInput: ElementRef;
  show: number;
  parts: any;
  extractedUrl: any;
  productsIndex: any;
  constructor(private vizseekService: VizseekService,
    private routingService: RoutingService,
    private router: Router,
    private dialog: MatDialog,
    private overlay: Overlay,
    private secureGuard: SecureGuard) {
  }

  //Viszeek Implementaion for Search with image
  openFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    event.target.value = '';
    if (file) {
      const formData = new FormData();
      formData.append('imgCheck', file);

      this.vizseekService.getVizseekUrl(formData).pipe(takeUntil(this.secureSubscription$)).subscribe(
        (response) => {
          this.vizseekService.vizseekData.next(response);

          this.parts = response.url.split('/');
          this.productsIndex = this.parts.indexOf('Products');

          if (this.productsIndex !== -1 && this.productsIndex + 1 < this.parts.length) {
            this.extractedUrl = this.parts.slice(this.productsIndex).join('/');
          }
          if (response.url == '/Products/c/NA-000') {

            this.router.navigate([this.extractedUrl]);
            this.dialog.open(KbVizseekNoresultsPopupComponent, { panelClass: 'custom-vizseek-Noresults' });
            event.target.value = '';
          }
          else {
            this.router.navigate([this.extractedUrl]);
            this.dialog.open(KbVizseekYesPopupComponent, { scrollStrategy: this.overlay.scrollStrategies.noop(), panelClass: 'custom-dialog-vizseek-container' });
            event.target.value = '';
          }

        },
        (error) => {
          console.error('Error uploading image:', error);
          event.target.value = '';
        }
      );
      event.target.value = '';
    }


  }
  ngAfterViewInit() {
    this.secureGuard.successMsg$.pipe(takeUntil(this.secureSubscription$)).subscribe((currentState: boolean) => {
      this.state = currentState;
    })
  }

  ngOnDestroy() {
    this.secureSubscription$.next();
    this.secureSubscription$.complete();
  }
}
